const ITEMS = [
  "Lavoriamo a %",
  "Solo Saloni da Parrucchiere",
  "Paghi solo sull'aumento di fatturato",
  "Contratto non vincolante",
  "Nessun minimo di spesa pubblicitaria",
  "Un solo referente dedicato",
];

export const Marquee = () => (
  <div className="bg-[#D83A52] py-4 overflow-hidden select-none" data-testid="editorial-marquee">
    <div className="pv-marquee flex items-center gap-10 whitespace-nowrap">
      {[...ITEMS, ...ITEMS, ...ITEMS].map((item, i) => (
        <span key={i} className="flex items-center gap-10">
          <span className="font-display italic text-white text-xl tracking-wide">{item}</span>
          <span className="text-[#2B1930] text-lg">✦</span>
        </span>
      ))}
    </div>
  </div>
);
